import { render, staticRenderFns } from "./sk-checkbox-img.vue?vue&type=template&id=ec6f9bfa&scoped=true&"
import script from "./sk-checkbox-img.vue?vue&type=script&lang=js&"
export * from "./sk-checkbox-img.vue?vue&type=script&lang=js&"
import style0 from "./sk-checkbox-img.vue?vue&type=style&index=0&id=ec6f9bfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6f9bfa",
  null
  
)

export default component.exports